import { AccountManager } from "applesauce-accounts";
import { PasswordAccount, registerCommonAccountTypes } from "applesauce-accounts/accounts";
import { NostrConnectSigner } from "applesauce-signers";
import { fromEvent, merge, skip } from "rxjs";

import AndroidSignerAccount from "../classes/accounts/android-signer-account";
import { CAP_IS_NATIVE } from "../env";
import { nostrConnectPublish, nostrConnectSubscription } from "../helpers/applesauce";
import { logger } from "../helpers/debug";
import { requestPinUnlock } from "./pin-unlock";
import localSettings from "./preferences";

// Setup nostr connect signer
NostrConnectSigner.subscriptionMethod = nostrConnectSubscription;
NostrConnectSigner.publishMethod = nostrConnectPublish;

const log = logger.extend("Accounts");

const accounts = new AccountManager();
registerCommonAccountTypes(accounts);

// Setup password unlock prompt (shows in-app modal instead of browser prompt)
PasswordAccount.requestUnlockPassword = async () => {
  return requestPinUnlock();
};

// add android signer if native
if (CAP_IS_NATIVE) accounts.registerType(AndroidSignerAccount);

// load all accounts
log("Loading accounts...");
accounts.fromJSON(localSettings.accounts.value, true);

// save accounts to database when they change
accounts.accounts$.pipe(skip(1)).subscribe(async () => {
  const json = accounts.toJSON();
  await localSettings.accounts.next(json);
});

// load last active account from session storage or local settings
const lastPubkey = localSettings.activeAccount.value;
const lastAccount = lastPubkey && accounts.getAccountForPubkey(lastPubkey);
if (lastAccount) accounts.setActive(lastAccount);

// When window is focused, save active pubkey to session storage
// This should allow new tabs to use the last active tabs pubkey by default
merge(fromEvent(window, "focus"), accounts.active$.pipe(skip(1))).subscribe(() => {
  const account = accounts.active;

  if (localSettings.activeAccount.value === (account?.id ?? null)) return;

  if (account) localSettings.activeAccount.next(account.pubkey);
  else localSettings.activeAccount.clear();
});

export default accounts;
